// import { ConfigProvider, App as AntApp, theme } from 'antd';
// import QueryProvider from './services/react-query';
// import RoutesWrapper from './routes/RoutesWrapper';
// import { useSelector } from 'react-redux';
// import { useEffect } from 'react';
// import en from './localization/en';
// import ar from './localization/ar';
// import 'react-phone-number-input/style.css';

// function App() {
//   const { currentLang, darkMode } = useSelector((state) => state.user);
//   // console.log(currentLang);
//   const t = currentLang === 'en' ? en : ar;
//   useEffect(() => {
//     if (currentLang) {
//       document
//         .getElementsByTagName('html')[0]
//         .setAttribute('lang', currentLang);
//     }
//   }, [currentLang]);
//   return (
//     <QueryProvider>
//       <ConfigProvider
//         direction={currentLang === 'en' ? 'ltr' : 'rtl'}
//         theme={{
//           algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
//           token: {
//             fontFamily:
//               currentLang === 'en' ? 'Public Sans, serif' : 'Cairo, serif',
//             // colorPrimary: '#687cfe',
//             colorPrimary: '#0B9640',
//             // colorLinkHover: darkMode ? '#fff' : '#ccc', // color link
//             // colorLink: darkMode ? '#0bb197' : '#ccc',
//             colorBgLayout: darkMode ? '#303841' : '#fbf7f4', // background layout
//             colorBgContainer: darkMode ? '#38414a' : '#fff', // background table && card
//             contentFontSize: 20,
//             fontWeight: 600,
//             borderRadius: 4,
//             fontSize: 16,
//             controlHeight: 40,
//             fontSizeXL: 18,
//             fontSizeHeading5: 16,
//             fontSizeHeading4: 18,
//             fontSizeHeading3: 22,
//             fontSizeHeading2: 25,
//             fontSizeHeading1: 32,
//             marginMD: 24,
//             wireframe: false,
//             marginLG: 32,
//             marginXL: 40,
//             paddingMD: 24,
//             paddingLG: 32,
//             paddingXL: 40,
//             borderRadiusSM: 4,
//             borderRadiusLG: 12,
//             borderRadiusXS: 4,
//           },
//           components: {
//             Table: {
//               stickyScrollBarBg: `background: -webkit-gradient(
//                                     linear,
//                                     left bottom,
//                                     left top,
//                                   )`,
//             },
//             Select: {
//               popupMatchSelectWidth: false,
//             },
//           },
//         }}
//       >
//         <AntApp>
//           <RoutesWrapper t={t} />
//         </AntApp>
//       </ConfigProvider>
//     </QueryProvider>
//   );
// }

// export default App;
import { ConfigProvider, App as AntApp, theme } from 'antd';
import QueryProvider from './services/react-query';
import RoutesWrapper from './routes/RoutesWrapper';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import en from './localization/en';
import ar from './localization/ar';
import 'react-phone-number-input/style.css';

function App() {
  const { currentLang, darkMode } = useSelector((state) => state.user);
  // console.log(currentLang);
  const t = currentLang === 'en' ? en : ar;
  useEffect(() => {
    if (currentLang) {
      document
        .getElementsByTagName('html')[0]
        .setAttribute('lang', currentLang);
    }
  }, [currentLang]);
  return (
    <QueryProvider>
      <ConfigProvider
        direction={currentLang === 'en' ? 'ltr' : 'rtl'}
        theme={{
          // algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            // fontFamily: 'Tajawal, sans-serif',
            fontFamily:
              currentLang === 'ar'
                ? 'Comfortaa, sans-serif'
                : 'Tajawal, sans-serif',
            // colorPrimary: '#0344DC',
            colorPrimary: '#079661',
            colorBgLayout: '#f5f5f5', // background layout
            colorBgContainer: '#FFFFFFA3', // background table && card
            colorTextHeading: '#374151', // text heading
            colorText: '#374151', // text
            // colorTextDescription: '#374151', // text description
            colorTextPlaceholder: '#767676', // text placeholder
            // colorTextBase: '#374151', // text base
            // colorTextLightSolid: '#374151', // text light solid & color button
            colorTextLight: '#374151', // text light
            colorTextQuaternary: '#374151', // text quaternary
            colorTextTertiary: '#374151', // text tertiary
            colorTextSecondary: '#374151', // text secondary

            contentFontSize: 20,
            fontWeight: 600,
            borderRadius: 12,
            fontSize: 16,
            controlHeight: 40,
            fontSizeXL: 18,
            fontSizeHeading5: 16,
            fontSizeHeading4: 18,
            fontSizeHeading3: 22,
            fontSizeHeading2: 25,
            fontSizeHeading1: 32,
            marginMD: 24,
            wireframe: false,
            marginLG: 32,
            marginXL: 40,
            paddingMD: 24,
            paddingLG: 32,
            paddingXL: 40,
            borderRadiusSM: 4,
            borderRadiusLG: 12,
            borderRadiusXS: 4,
          },
          components: {
            Table: {
              stickyScrollBarBg: `background: -webkit-gradient(
                                    linear,
                                    left bottom,
                                    left top,
                                  )`,
            },

            Select: {
              popupMatchSelectWidth: false,
              fontWeight: 600,
              controlHeight: 48,
              controlHeightLG: 56,
              controlHeightSM: 32,
              colorTextPlaceholder: '#767676',
              colorText: '#374151',
              colorBgContainer: '#fff',
              borderRadius: 12,
              colorTextDisabled: '#6A6A6A',
              colorBgContainerDisabled: '#F2F2F2',
            },
            Button: {
              fontSize: 14,
              fontSizeLG: 16,
              fontWeight: 700,
              fontFamily: '"Comfortaa", sans-serif',
              // colorText: '#fff',
              // colorPrimary: '#0344DC',
              // colorBgContainer: '#fff',
              controlHeight: 48,
              controlHeightLG: 56,
              controlHeightSM: 40,
              borderRadius: 12,
              colorTextDisabled: '#6A6A6A',
              colorBgContainerDisabled: '#F2F2F2',
            },
            Input: {
              colorBgContainer: '#fff',
              controlHeight: 48,
              controlHeightLG: 56,
              controlHeightSM: 40,
              colorBorderBg: '#CFD0D43D',
              borderRadius: 12,
              colorTextDisabled: '#6A6A6A',
              colorBgContainerDisabled: '#F2F2F2',
            },
            DatePicker: {
              colorBgContainer: '#fff',
              controlHeight: 48,
              controlHeightLG: 56,
              controlHeightSM: 40,
              colorBorderBg: '#CFD0D43D',
              borderRadius: 12,
              colorTextDisabled: '#6A6A6A',
              colorBgContainerDisabled: '#F2F2F2',
            },
            Form: {
              labelFontSize: 12,
              labelFontWeight: 700,
              labelColor: '#767676',
            },
            Checkbox: {
              controlHeight: 28,
              controlHeightLG: 32,
              controlHeightSM: 20,
              borderRadius: 12,
            },
          },
        }}
      >
        <AntApp>
          <RoutesWrapper t={t} />
        </AntApp>
      </ConfigProvider>
    </QueryProvider>
  );
}

export default App;
